/**
 * 金币喷泉的大小档（2026-10-22 leo 定：喷泉大小跟到手金额走，不跟落在哪座喷泉）。
 *
 * 档位类型 band_kind = "size"，不复用 tier：数数埋点把有 tier 档的副玩法格都当大奖格（analytics/roll-facts.ts）。
 * 服务端按 X/g 选档（tile-band.ts pickEconomyBand），客户端按 detail.band.id 找到这一档、读 payload.size 演对应大小。
 * 取值写死三个，与客户端三座喷泉一一对应；管端只给选这三个，发布闸也认这三个。
 *
 * ⚠️ 本文件必须零依赖：发布校验 config-validate.ts 与管端前端都直接 import 它。
 */
export const FOUNTAIN_SIZES = ["small", "mid", "large"] as const;
export type FountainSize = (typeof FOUNTAIN_SIZES)[number];

export const isFountainSize = (v: unknown): v is FountainSize =>
  typeof v === "string" && (FOUNTAIN_SIZES as readonly string[]).includes(v);
